export { default as Category } from './category';
export { default as Continuous } from './continuous';
export { default as Base } from './base';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/esm/legend/index.js
// module id = null
// module chunks = 